import Rest from "@/services/api_config/RestApi";

export default {
  getPages(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    return Rest().get("ticketko/com/page?" + data.substring(1));
  },
  getPage(id) {
    return Rest().get("ticketko/com/page/" + id);
  },
  addPage(data) {
    return Rest().put("ticketko/com/add-page", data);
  },
  editPage(id, data) {
    return Rest().patch("ticketko/com/page/" + id, data);
  },
  deletePage(id) {
    return Rest().delete("ticketko/com/page/" + id);
  },
  getModules(params) {
    var data = ``;
    if (
      params.page_id !== null &&
      params.page_id !== undefined &&
      params.page_id !== ""
    ) {
      data += `&page_id=${params.page_id}`;
    }
    return Rest().get("ticketko/com/module?" + data.substring(1));
  },
  getModule(id) {
    return Rest().get("ticketko/com/module/" + id);
  },
  editModule(id, data) {
    return Rest().patch("ticketko/com/module/" + id, data);
  },
  addModule(data) {
    return Rest().put("ticketko/com/add-module", data);
  },
  deleteModule(id) {
    return Rest().delete("ticketko/com/module/" + id);
  },
  getRoles(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("ticketko/com/role?" + data.substring(1));
  },
  getRole(id) {
    return Rest().get("ticketko/com/role/" + id);
  },
  editRole(id, data) {
    return Rest().patch("ticketko/com/role/" + id, data);
  },
  deleteRole(id) {
    return Rest().delete("ticketko/com/role/" + id);
  },
  addRole(data) {
    return Rest().put("ticketko/com/add-role", data);
  },
  getEmployees(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("ticketko/com/employee?" + data.substring(1));
  },
  getEmployee(id) {
    return Rest().get("ticketko/com/employee/" + id);
  },
  addEmployee(data) {
    return Rest().put("ticketko/com/add-employee", data);
  },
  editEmployee(id, data) {
    return Rest().patch("ticketko/com/employee/" + id, data);
  },
  deleteEmployee(id) {
    return Rest().delete("ticketko/com/employee/" + id);
  },
  uploadEmployees(data) {
    return Rest().put("ticketko/com/upload-employee", data);
  },
  getUnassignedEmployees(params) {
    let data = ``;
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("ticketko/com/unassigned-employee?" + data.substring(1));
  },
  assignEmployees(params) {
    return Rest().post("ticketko/com/assign-employee/", params);
  },
  getUser(id) {
    return Rest().get("jti/user/" + id);
  },
  getCompanies(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("ticketko/com/sub-company?" + data.substring(1));
  },
  getCompany(id) {
    return Rest().get("ticketko/com/sub-company/" + id);
  },
  getManageCompany(id) {
    return Rest().get("ticketko/com/sub-company/manage/" + id);
  },
  getCompanySettings(id) {
    return Rest().get("ticketko/com/sub-company/settings/" + id);
  },
  editCompanySettings(id, body) {
    return Rest().patch("ticketko/com/sub-company/settings/" + id, body);
  },
  getSubCompanies(params) {
    var data = ``;
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("jti/sub-company?" + data.substring(1));
  },
  getAccessCards(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("ticketko/com/access-card?" + data.substring(1));
  },
  getAccessCard(id) {
    return Rest().get("ticketko/com/access-card/" + id);
  },
  addAccessCard(data) {
    return Rest().put("ticketko/com/access-card", data);
  },
  deleteAccessCard(id) {
    return Rest().delete("ticketko/com/access-card/" + id);
  },
  getUnassignedAccessCards(params) {
    var data = ``;
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get(
      "ticketko/com/unassigned-access-card?" + data.substring(1)
    );
  },
  uploadAccessCards(data) {
    return Rest().put("ticketko/com/upload-access-card", data);
  },
  getEmployees(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("ticketko/com/employee?" + data.substring(1));
  },
  getEmployee(id) {
    return Rest().get("ticketko/com/employee/" + id);
  },
  addEmployee(data) {
    return Rest().put("ticketko/com/add-employee", data);
  },
  editEmployee(id, data) {
    return Rest().patch("ticketko/com/employee/" + id, data);
  },
  deleteEmployee(id) {
    return Rest().delete("ticketko/com/employee/" + id);
  },
  getSoftwareSerials(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.is_assigned !== null &&
      params.is_assigned !== undefined &&
      params.is_assigned !== ""
    ) {
      data += `&is_assigned=${params.is_assigned}`;
    }
    return Rest().get("ticketko/com/software-serial?" + data.substring(1));
  },
  getSoftwareSerial(id) {
    return Rest().get("ticketko/com/software-serial/" + id);
  },
  addSoftwareSerial(data) {
    return Rest().put("ticketko/com/add-software-serial", data);
  },
  editSoftwareSerial(id, data) {
    return Rest().patch("ticketko/com/software-serial/" + id, data);
  },
  deleteSoftwareSerial(id) {
    return Rest().delete("ticketko/com/software-serial/" + id);
  },
  getDevices(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("ticketko/com/device?" + data.substring(1));
  },
  getDevice(id) {
    return Rest().get("ticketko/com/device/" + id);
  },
  addDevice(data) {
    return Rest().put("ticketko/com/add-device", data);
  },
  editDevice(id, data) {
    return Rest().patch("ticketko/com/device/" + id, data);
  },
  deleteDevice(id) {
    return Rest().delete("ticketko/com/device/" + id);
  },
  getUnassignedDevices(params) {
    let data = ``;
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("ticketko/com/unassigned-device?" + data.substring(1));
  },
  assignDevices(data) {
    return Rest().post("ticketko/com/assign-device/", data);
  },
  getTerminals(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("ticketko/com/terminal?" + data.substring(1));
  },
  getTerminal(id) {
    return Rest().get("ticketko/com/terminal/" + id);
  },
  addTerminal(data) {
    return Rest().put("ticketko/com/terminal", data);
  },
  editTerminal(id, data) {
    return Rest().patch("ticketko/com/terminal/" + id, data);
  },
  deleteTerminal(id) {
    return Rest().delete("ticketko/com/terminal/" + id);
  },
  getBounds(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("ticketko/com/bound?" + data.substring(1));
  },
  getBound(id) {
    return Rest().get("ticketko/com/bound/" + id);
  },
  addBound(data) {
    return Rest().put("ticketko/com/bound", data);
  },
  editBound(id, data) {
    return Rest().patch("ticketko/com/bound/" + id, data);
  },
  deleteBound(id) {
    return Rest().delete("ticketko/com/bound/" + id);
  },
  getFuelStations(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("ticketko/com/fuel-station?" + data.substring(1));
  },
  getFuelStation(id) {
    return Rest().get("ticketko/com/fuel-station/" + id);
  },
  addFuelStation(data) {
    return Rest().put("ticketko/com/fuel-station", data);
  },
  editFuelStation(id, data) {
    return Rest().patch("ticketko/com/fuel-station/" + id, data);
  },
  deleteFuelStation(id) {
    return Rest().delete("ticketko/com/fuel-station/" + id);
  },
  getVehicleTypes(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("ticketko/com/vehicle-type?" + data.substring(1));
  },
  getVehicleType(id) {
    return Rest().get("ticketko/com/vehicle-type/" + id);
  },
  addVehicleType(data) {
    return Rest().put("ticketko/com/vehicle-type", data);
  },
  editVehicleType(id, data) {
    return Rest().patch("ticketko/com/vehicle-type/" + id, data);
  },
  deleteVehicleType(id) {
    return Rest().delete("ticketko/com/vehicle-type/" + id);
  },
  getVehicleLayouts(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("ticketko/com/vehicle-layout?" + data.substring(1));
  },
  getVehicleLayout(id) {
    return Rest().get("ticketko/com/vehicle-layout/" + id);
  },
  addVehicleLayout(data) {
    return Rest().put("ticketko/com/vehicle-layout", data);
  },
  editVehicleLayout(id, data) {
    return Rest().patch("ticketko/com/vehicle-layout/" + id, data);
  },
  deleteVehicleLayout(id) {
    return Rest().delete("ticketko/com/vehicle-layout/" + id);
  },
  getVehicles(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("ticketko/com/vehicle?" + data.substring(1));
  },
  getVehicle(id) {
    return Rest().get("ticketko/com/vehicle/" + id);
  },
  addVehicle(data) {
    return Rest().put("ticketko/com/vehicle", data);
  },
  editVehicle(id, data) {
    return Rest().patch("ticketko/com/vehicle/" + id, data);
  },
  deleteVehicle(id) {
    return Rest().delete("ticketko/com/vehicle/" + id);
  },
  getViolations(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("ticketko/com/violation?" + data.substring(1));
  },
  getViolation(id) {
    return Rest().get("ticketko/com/violation/" + id);
  },
  addViolation(data) {
    return Rest().put("ticketko/com/violation", data);
  },
  editViolation(id, data) {
    return Rest().patch("ticketko/com/violation/" + id, data);
  },
  deleteViolation(id) {
    return Rest().delete("ticketko/com/violation/" + id);
  },
  getExpenses(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("ticketko/com/expense?" + data.substring(1));
  },
  getExpense(id) {
    return Rest().get("ticketko/com/expense/" + id);
  },
  addExpense(data) {
    return Rest().put("ticketko/com/expense", data);
  },
  editExpense(id, data) {
    return Rest().patch("ticketko/com/expense/" + id, data);
  },
  deleteExpense(id) {
    return Rest().delete("ticketko/com/expense/" + id);
  },
  getPassengerTypes(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("ticketko/com/passenger-type?" + data.substring(1));
  },
  getPassengerType(id) {
    return Rest().get("ticketko/com/passenger-type/" + id);
  },
  addPassengerType(data) {
    return Rest().put("ticketko/com/passenger-type", data);
  },
  editPassengerType(id, data) {
    return Rest().patch("ticketko/com/passenger-type/" + id, data);
  },
  deletePassengerType(id) {
    return Rest().delete("ticketko/com/passenger-type/" + id);
  },
  getPaymentTypes(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("ticketko/com/payment-type?" + data.substring(1));
  },
  getPaymentType(id) {
    return Rest().get("ticketko/com/payment-type/" + id);
  },
  addPaymentType(data) {
    return Rest().put("ticketko/com/payment-type", data);
  },
  editPaymentType(id, data) {
    return Rest().patch("ticketko/com/payment-type/" + id, data);
  },
  deletePaymentType(id) {
    return Rest().delete("ticketko/com/payment-type/" + id);
  },
  getManualTypes(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("ticketko/com/manual-type?" + data.substring(1));
  },
  getManualType(id) {
    return Rest().get("ticketko/com/manual-type/" + id);
  },
  addManualType(data) {
    return Rest().put("ticketko/com/manual-type", data);
  },
  editManualType(id, data) {
    return Rest().patch("ticketko/com/manual-type/" + id, data);
  },
  deleteManualType(id) {
    return Rest().delete("ticketko/com/manual-type/" + id);
  },
  getDltbEmployees(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.designation !== null &&
      params.designation !== undefined &&
      params.designation !== ""
    ) {
      data += `&designation=${params.designation}`;
    }

    return Rest().get("ticketko/com/dltb/employee?" + data.substring(1));
  },
  getEndOfDay(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("ticketko/com/end-of-day?" + data.substring(1));
  },
  getEndOfDayTripSummary(id) {
    return Rest().get("ticketko/com/end-of-day/trip-summary/" + id);
  },
  closeEndOfDay(id) {
    return Rest().patch("ticketko/com//end-of-day/close/" + id);
  },
  getEndOfDayTickets(id) {
    return Rest().get("ticketko/com/end-of-day/ticket/" + id);
  },
  getEndOfDayBaggages(id) {
    return Rest().get("ticketko/com/end-of-day/baggage/" + id);
  },
  getEndOfDayAbstract(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }

    return Rest().get("ticketko/com/end-of-day/abstract?" + data.substring(1));
  },
  generateAbstract(data) {
    return Rest().post("ticketko/com/end-of-day/generate-abstract", data);
  },
  getRoutes(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("ticketko/com/route?" + data.substring(1));
  },
  getEODSummaryReport(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.date !== null &&
      params.date !== undefined &&
      params.date !== ""
    ) {
      data += `&date=${params.date}`;
    }
    return Rest().get("ticketko/report/eod-summary?" + data.substring(1));
  },
  getExecutiveReport(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.route !== null &&
      params.route !== undefined &&
      params.route !== ""
    ) {
      data += `&route=${params.route}`;
    }
    if (
      params.month !== null &&
      params.month !== undefined &&
      params.month !== ""
    ) {
      data += `&month=${params.month}`;
    }
    return Rest().get("ticketko/report/executive?" + data.substring(1));
  },
  getLTFRBReport(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get("ticketko/report/ltfrb?" + data.substring(1));
  },
};
